<form class="gap-lg grid" [formGroup]="form">
  <div hlmField>
    <label hlmFieldLabel for="input-nom" labelRequired>Nom de la caractéristique</label>
    <input id="input-nom" hlmInput type="text" formControlName="nom" />
    @if (nom.hasError('required')) {
      <hlm-field-error>Merci de renseigner un nom</hlm-field-error>
    }
    @if (nom.hasError('notUnique')) {
      <hlm-field-error>Cette caractéristique existe déjà.</hlm-field-error>
    }
  </div>
</form>
